"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarehouseProviderAutoSaveFields = exports.WmsIntegration = exports.Environment = void 0;
var Environment;
(function (Environment) {
    Environment["ProdA"] = "ProdA";
    Environment["ProdB"] = "ProdB";
})(Environment || (exports.Environment = Environment = {}));
var WmsIntegration;
(function (WmsIntegration) {
    WmsIntegration["LOGIWA"] = "logiwa";
    WmsIntegration["LOGIWAIO"] = "logiwaio";
    WmsIntegration["DELIVERR"] = "deliverr";
    WmsIntegration["OPTORO"] = "optoro";
    WmsIntegration["FBA"] = "fba";
    WmsIntegration["WFS"] = "wfs";
})(WmsIntegration || (exports.WmsIntegration = WmsIntegration = {}));
exports.WarehouseProviderAutoSaveFields = ["createdAt"];
//# sourceMappingURL=WarehouseProvider.js.map